var _defs, _g, _g2, _g3, _g4, _path, _g5, _path2, _g6, _g7, _g8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllLocater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5195",
    "data-name": "Group 5195",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 911,
    height: 694.651,
    viewBox: "0 0 911 694.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    width: 911,
    height: 694.651,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1760",
    "data-name": "Rectangle 1760",
    width: 788.369,
    height: 455.165,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4eff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    "data-name": "Rectangle 1761",
    width: 788.369,
    height: 455.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4eff7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13958",
    "data-name": "Path 13958",
    d: "M445.2,532.62,51.014,305.034,445.193,77.455,839.383,305.04Z",
    transform: "translate(-51.014 -77.455)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 539.345,
    height: 311.392,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    width: 727.079,
    height: 286.968,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1773",
    "data-name": "Rectangle 1773",
    width: 3.836,
    height: 0.513,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1776",
    "data-name": "Rectangle 1776",
    width: 67.39,
    height: 20.858,
    fill: "#fbb516"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    width: 20.858,
    height: 17.586,
    fill: "#fbb516"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779",
    "data-name": "Rectangle 1779",
    width: 4.988,
    height: 4.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1780",
    "data-name": "Rectangle 1780",
    width: 4.986,
    height: 4.986,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    "data-name": "Rectangle 1784",
    width: 4.986,
    height: 4.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    "data-name": "Rectangle 1786",
    width: 4.988,
    height: 4.986,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    "data-name": "Rectangle 1787",
    width: 6.334,
    height: 3.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    width: 6.332,
    height: 3.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1790",
    "data-name": "Rectangle 1790",
    width: 6.334,
    height: 3.657,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 6.334,
    height: 3.658,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 6.332,
    height: 3.658,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1819",
    "data-name": "Rectangle 1819",
    width: 150.76,
    height: 174.005,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14084",
    "data-name": "Path 14084",
    d: "M109.157,73.826l4.452,6.292,3.233-1.866-4.452-6.294Z",
    transform: "translate(-109.157 -71.959)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -12.193,
    y1: 8.075,
    x2: -12.08,
    y2: 8.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#eae7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#e9e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efeaea"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14087",
    "data-name": "Path 14087",
    d: "M103.828,76.9,108.28,83.2l3.233-1.867-4.452-6.292Z",
    transform: "translate(-103.828 -75.036)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -11.591,
    y1: 7.733,
    x2: -11.478,
    y2: 7.733,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14099",
    "data-name": "Path 14099",
    d: "M72.66,94.9l4.452,6.291,3.232-1.867-4.451-6.291Z",
    transform: "translate(-72.66 -93.033)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14102",
    "data-name": "Path 14102",
    d: "M67.331,97.977l4.451,6.292,3.233-1.867L70.563,96.11Z",
    transform: "translate(-67.331 -96.11)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14111",
    "data-name": "Path 14111",
    d: "M83.318,88.746l4.453,6.291L91,93.171l-4.452-6.292Z",
    transform: "translate(-83.318 -86.879)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14114",
    "data-name": "Path 14114",
    d: "M77.989,91.823l4.452,6.291,3.233-1.866-4.452-6.292Z",
    transform: "translate(-77.989 -89.956)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14120",
    "data-name": "Path 14120",
    d: "M88.647,85.668,93.1,91.96l3.232-1.866L91.88,83.8Z",
    transform: "translate(-88.647 -83.802)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14133",
    "data-name": "Path 14133",
    d: "M21.105,97.809l3.232,1.867L30.627,76.1l-3.233-1.866Z",
    transform: "translate(-21.105 -74.234)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14136",
    "data-name": "Path 14136",
    d: "M26.434,100.886l3.233,1.867,6.289-23.576-3.233-1.866Z",
    transform: "translate(-26.434 -77.311)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14145",
    "data-name": "Path 14145",
    d: "M10.446,91.657l3.232,1.866,6.29-23.578-3.233-1.866Z",
    transform: "translate(-10.446 -68.079)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14148",
    "data-name": "Path 14148",
    d: "M15.775,94.732,19.008,96.6,25.3,73.023l-3.232-1.867Z",
    transform: "translate(-15.775 -71.156)",
    fill: "#e4eff7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91298c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91298c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x2: 0.943,
    y2: 1.679,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x2: 0.188,
    y2: 1.445,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13964",
    "data-name": "Path 13964",
    d: "M235.069,115.741c-.008.306-.025.617-.048.928-.008.094-.017.188-.024.282q-.032.343-.071.685c-.013.1-.024.2-.038.3-.027.2-.057.407-.091.61-.014.094-.028.185-.045.279-.05.3-.108.592-.171.89q-.084.393-.181.788c-.02.079-.042.158-.062.237-.048.186-.1.37-.147.555-.018.067-.039.136-.059.2-.053.186-.108.371-.165.557-.028.091-.057.184-.087.273-.043.139-.09.278-.136.415-.126.371-.259.744-.4,1.114-.024.066-.05.13-.076.195q-.185.467-.383.932c-.032.079-.066.157-.1.236q-.229.521-.475,1.036c-.032.067-.066.135-.1.2q-.212.437-.44.868c-.042.08-.083.161-.128.241-.179.339-.367.676-.561,1.008l-.1.172c-.178.3-.362.6-.548.9-.043.069-.088.142-.133.21-.223.346-.45.688-.685,1.023l-.136.193c-.264.373-.535.742-.813,1.1-.084.111-.172.217-.258.327s-.184.23-.275.345-.181.214-.272.322-.189.226-.285.336c-.045.052-.091.1-.136.151q-.257.294-.521.578c-.074.08-.149.158-.224.237q-.227.24-.458.471c-.1.1-.189.191-.285.283-.063.063-.128.125-.193.186-.13.123-.261.244-.391.366-.059.052-.115.105-.172.157q-.284.254-.568.5c-.011.007-.02.015-.029.022-.182.154-.364.3-.549.449l-.185.143c-.136.105-.271.209-.409.31l-.206.15c-.139.1-.278.2-.418.292-.062.042-.123.086-.186.128-.2.133-.4.264-.6.388-.149.091-.3.179-.442.264-.21.121-.418.234-.625.342-.053.028-.107.056-.161.083-.186.1-.373.188-.556.273l-.063.029c-.191.087-.378.167-.566.244s-.4.158-.6.23c-.049.017-.1.036-.144.053-.247.084-.491.158-.733.226-.139.038-.278.07-.415.1-.067.014-.135.034-.2.049q-.309.065-.61.114H216.9c-.186.028-.371.05-.554.067-.059.006-.119.008-.179.013-.13.01-.261.018-.39.021l-.172,0c-.133,0-.265,0-.4-.006-.046,0-.094,0-.139-.006-.17-.008-.339-.024-.506-.043-.034,0-.067-.011-.1-.015-.135-.018-.268-.041-.4-.066l-.135-.028c-.151-.031-.3-.067-.447-.109l-.029-.007c-.156-.046-.307-.1-.457-.151l-.121-.048c-.121-.048-.24-.1-.356-.153l-.094-.041c-.153-.074-.3-.151-.447-.237l8.885,5.164.073.042c.123.069.248.132.376.193l.091.042c.072.032.142.067.215.1.048.02.1.036.144.056s.08.031.121.045c.147.056.3.107.449.15l.007,0,.029.008c.147.041.3.077.449.109l.133.028c.048.008.094.018.14.028.087.014.175.025.262.038.035,0,.069.011.1.014.149.018.3.034.451.043h.055q.067,0,.139,0c.13.006.264.008.4.007q.086,0,.172,0c.043,0,.088,0,.132,0,.086,0,.172-.011.258-.017.059-.006.118-.008.179-.014.182-.017.366-.038.552-.067h.018c.2-.029.405-.067.611-.112.067-.014.135-.034.2-.049.125-.029.25-.056.376-.091.013,0,.027-.008.039-.013.243-.066.485-.14.732-.226.048-.015.1-.036.144-.052.2-.073.4-.149.6-.23l.08-.032c.161-.066.324-.137.486-.212.02-.01.041-.021.063-.031.184-.086.369-.177.557-.272l.161-.084c.206-.109.415-.221.622-.341.149-.085.3-.174.443-.264.2-.125.4-.255.6-.39l.188-.126c.14-.1.279-.192.418-.292.067-.05.137-.1.206-.151.136-.1.273-.2.409-.31.062-.048.123-.094.185-.143q.275-.219.549-.447l.028-.024c.191-.16.38-.327.566-.495.059-.052.116-.107.174-.158.132-.121.262-.241.392-.364l.192-.188.151-.144c.046-.046.088-.093.135-.137.153-.156.306-.311.457-.471l.226-.237c.177-.191.349-.383.521-.578.035-.042.073-.081.109-.123l.025-.028c.1-.112.191-.226.286-.339s.181-.212.269-.321.185-.23.278-.346c.08-.1.163-.2.241-.3l.017-.021q.416-.538.813-1.1l.08-.108.056-.083q.351-.5.684-1.023c.017-.025.035-.048.05-.073.028-.046.055-.092.084-.139.186-.3.37-.594.548-.9.024-.041.05-.081.074-.122l.027-.052c.193-.331.38-.669.562-1.006l.05-.091c.027-.05.05-.1.077-.151q.227-.431.439-.866c.024-.048.049-.094.072-.142l.028-.059c.164-.343.322-.69.474-1.036.013-.029.027-.057.039-.085.022-.05.039-.1.062-.15.132-.311.259-.621.38-.932.02-.046.039-.093.057-.139l.02-.056c.143-.371.276-.743.4-1.117l.039-.107c.034-.1.065-.2.1-.306l.088-.273c.056-.185.112-.371.165-.556.018-.069.039-.135.057-.2l.013-.041c.046-.171.091-.343.135-.514l.063-.238c.063-.261.125-.523.179-.782v0c.065-.3.121-.6.172-.89.015-.094.029-.185.043-.279.034-.2.064-.408.092-.61,0-.042.014-.087.018-.129.008-.059.011-.115.018-.174q.042-.345.072-.685c.008-.094.017-.189.022-.282.024-.311.041-.622.049-.929a13.4,13.4,0,0,0-.981-5.743,7.246,7.246,0,0,0-2.956-3.441l-8.886-5.164c2.523,1.468,4.05,4.65,3.939,9.186",
    transform: "translate(-211.973 -106.555)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.56,
    cy: 1.151,
    r: 1.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c819d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#a823cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#5341bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324db5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13965",
    "data-name": "Path 13965",
    d: "M237.249,95.234c-.212,0-.426,0-.642.011h-.1l-.053,0q-.4.019-.806.059c-.055,0-.109.011-.165.017-.28.029-.562.063-.848.108h-.011q-.511.078-1.03.189l-.08.015c-.334.073-.671.154-1.011.245l-.083.02-.07.021c-.181.05-.366.1-.55.158-.042.014-.083.025-.126.038-.226.07-.454.144-.683.223-.063.022-.126.046-.191.067-.167.059-.334.119-.5.182-.084.031-.167.064-.251.1-.15.057-.3.119-.453.181l-.139.053c-.036.015-.073.034-.109.05-.217.09-.436.186-.656.285l-.129.057c-.259.119-.519.244-.782.373l-.206.105c-.2.1-.405.206-.61.315l-.229.121c-.266.144-.533.292-.8.447-.405.233-.807.479-1.208.732-.129.081-.257.167-.387.252-.271.175-.541.353-.809.538q-.223.154-.446.311c-.248.177-.5.355-.743.538-.15.112-.3.224-.45.339-.248.189-.5.383-.742.58-.139.111-.279.22-.418.334-.279.229-.555.464-.83.7-.1.087-.2.171-.3.259-.374.327-.743.663-1.11,1.005-.078.071-.154.149-.231.221-.244.23-.486.46-.728.7-.053.052-.105.107-.16.16l-.2.2c-.336.339-.671.683-1,1.033a.251.251,0,0,0-.027.028q-.5.536-.994,1.091l-.2.223c-.056.064-.115.128-.171.193-.151.174-.3.355-.451.531s-.32.376-.477.566c-.193.235-.384.474-.575.712-.151.191-.306.378-.454.571-.028.035-.057.069-.084.105-.289.371-.572.747-.854,1.128-.013.018-.025.036-.039.055q-.4.538-.781,1.086c-.032.046-.064.093-.1.14-.083.116-.163.234-.243.352-.213.311-.425.624-.632.939l-.276.421c-.07.108-.142.214-.21.321q-.225.355-.443.712c-.055.085-.109.171-.163.258q-.353.576-.694,1.158c-.028.049-.055.1-.083.146-.06.105-.119.21-.179.314-.2.349-.394.7-.586,1.05-.067.122-.135.244-.2.366-.045.081-.09.161-.133.244q-.29.542-.568,1.093c-.018.035-.035.071-.053.108-.157.313-.313.624-.463.936-.052.105-.1.212-.149.317-.062.129-.122.258-.182.387q-.265.568-.519,1.142c-.036.083-.076.167-.111.25-.014.029-.027.059-.039.088q-.28.643-.54,1.291c-.048.118-.094.234-.14.352-.081.2-.164.409-.244.613-.057.151-.111.3-.167.453s-.112.294-.164.442c-.146.4-.285.793-.419,1.189-.027.077-.055.156-.081.234l-.02.057c-.154.463-.3.924-.439,1.386-.041.13-.076.261-.115.39-.077.264-.157.526-.229.788-.024.084-.045.17-.067.254-.057.216-.114.433-.168.649-.076.289-.149.576-.216.865-.052.219-.1.439-.151.659-.035.153-.073.306-.105.46-.045.207-.084.414-.126.622-.01.052-.021.105-.032.157-.088.46-.17.92-.244,1.377l-.038.236c-.057.366-.111.733-.16,1.1-.008.066-.013.133-.022.2-.018.154-.035.308-.053.464-.036.322-.069.645-.1.964-.014.168-.028.335-.041.5-.024.325-.042.648-.059.971-.007.146-.017.294-.021.439-.018.463-.028.925-.027,1.382.055,19.176,18.82,31.652,23.989,34.724l8.885,5.164c-5.167-3.073-23.934-15.547-23.987-34.725,0-.457.008-.918.027-1.381,0-.146.013-.293.021-.439.015-.324.034-.646.059-.971.013-.167.027-.334.041-.5.029-.32.062-.642.1-.964.018-.156.032-.31.053-.464q.08-.648.182-1.3c.011-.077.024-.156.038-.234.074-.458.154-.917.244-1.378.01-.052.021-.105.032-.157.07-.36.15-.721.23-1.082.049-.219.1-.439.151-.657.069-.29.142-.578.216-.866.056-.216.109-.433.17-.649.094-.346.193-.692.294-1.04.039-.13.074-.259.114-.39q.221-.723.461-1.445c.025-.077.055-.156.08-.233.136-.4.275-.792.418-1.189.055-.147.111-.294.165-.443.133-.356.271-.709.412-1.064.046-.118.091-.236.139-.352q.282-.692.579-1.379c.036-.084.076-.167.112-.25.168-.383.342-.765.519-1.145.06-.128.119-.257.181-.384q.3-.631.613-1.253c.017-.036.035-.073.053-.109q.341-.673.7-1.336c.066-.123.133-.244.2-.366q.288-.528.587-1.05c.059-.105.118-.209.178-.314.255-.437.513-.873.777-1.3.053-.087.109-.172.161-.259q.324-.519.655-1.032c.093-.14.184-.282.278-.422q.311-.473.632-.939l.24-.352c.289-.412.58-.823.879-1.227.013-.017.025-.036.039-.053.306-.416.621-.828.936-1.234.15-.192.3-.38.454-.571.191-.238.381-.478.575-.714.157-.191.32-.377.478-.565.207-.244.412-.486.622-.725l.2-.224c.328-.369.659-.733.992-1.089l.027-.028q.5-.526,1-1.033c.067-.067.132-.135.2-.2.293-.292.589-.576.887-.858.077-.074.153-.149.231-.221.364-.343.736-.677,1.11-1,.1-.088.2-.174.3-.261.276-.237.552-.471.831-.7.139-.114.278-.223.416-.335.247-.2.493-.391.743-.582.149-.114.3-.226.45-.338.247-.182.493-.362.743-.537.147-.105.3-.21.444-.313.269-.185.538-.363.81-.538.129-.084.257-.17.387-.252q.6-.381,1.206-.732c.269-.154.536-.3.8-.446.076-.042.153-.081.228-.122q.3-.162.608-.315l.207-.1c.261-.129.523-.254.781-.373l.13-.057c.22-.1.437-.195.655-.287.083-.034.167-.067.248-.1.151-.062.3-.122.453-.179q.126-.05.252-.1c.167-.064.334-.123.5-.182.064-.021.129-.046.192-.069q.343-.118.683-.221c.041-.014.084-.025.126-.038.184-.056.367-.109.549-.16.05-.013.1-.025.153-.039.339-.091.676-.175,1.009-.245l.081-.017c.346-.073.69-.137,1.029-.189h.013c.285-.045.568-.078.848-.109.055,0,.109-.011.165-.015.271-.027.54-.048.806-.06.052,0,.1,0,.154,0,.216-.01.429-.013.643-.013h.139c.241,0,.481.011.719.025l.167.011c.188.014.376.029.559.05l.151.015c.221.027.443.06.66.1.049.007.1.017.144.027.172.031.342.066.512.1l.171.038c.209.05.415.1.62.163l.049.014c.186.056.373.115.554.178l.168.062c.163.057.322.119.482.184.036.017.074.031.111.045.192.081.381.167.568.258.046.022.093.045.137.069.149.074.3.151.44.231.076.042.153.083.229.126l-8.886-5.164-.137-.077c-.029-.018-.06-.032-.091-.049-.144-.08-.292-.157-.44-.23-.045-.024-.091-.048-.137-.07-.186-.091-.374-.177-.568-.257l-.027-.013-.083-.032q-.24-.1-.484-.185c-.055-.021-.111-.041-.167-.06-.182-.063-.367-.123-.554-.178-.014,0-.028-.01-.041-.013l-.01,0c-.2-.059-.411-.112-.62-.161l-.17-.038c-.17-.038-.341-.073-.513-.1-.034-.006-.066-.014-.1-.02l-.042-.007c-.219-.036-.439-.069-.663-.1-.049-.007-.1-.011-.149-.015-.185-.021-.371-.038-.561-.05-.035,0-.07-.008-.105-.01l-.06,0c-.238-.014-.478-.022-.721-.025h-.139",
    transform: "translate(-200.863 -95.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13966",
    "data-name": "Path 13966",
    d: "M218.837,138.563c.2-8.269,5.951-18.222,13.031-22.569.149-.091.3-.179.442-.264,7.616-4.4,13.781-.712,13.561,8.243-.2,8.266-5.951,18.222-13.03,22.569-.147.09-.294.178-.443.264a12.315,12.315,0,0,1-6.068,1.855c-4.553,0-7.65-3.706-7.493-10.1m13.435-36.2c-13.892,8.021-25.116,27.464-25.07,43.425.053,19.178,18.82,31.651,23.987,34.725a1.282,1.282,0,0,0,1.3-.122,3.711,3.711,0,0,0,1.3-1.381c5.131-9.037,23.772-43.2,23.717-62.266-.032-11.3-5.705-17.831-13.948-17.831a22.944,22.944,0,0,0-11.286,3.45",
    transform: "translate(-207.202 -98.915)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5094",
    "data-name": "Group 5094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5093",
    "data-name": "Group 5093",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5073",
    "data-name": "Group 5073",
    transform: "translate(104.707 239.485)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5072",
    "data-name": "Group 5072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5071",
    "data-name": "Group 5071",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13956",
    "data-name": "Path 13956",
    d: "M445.2,571.844,51.014,344.258,445.191,116.679,839.383,344.266Z",
    transform: "translate(-51.013 -116.679)",
    fill: "url(#linear-gradient)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5076",
    "data-name": "Group 5076",
    transform: "translate(104.707 198.87)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13957",
    "data-name": "Path 13957",
    d: "M445.2,552.057,51.014,324.47,445.191,96.891,839.383,324.478Z",
    transform: "translate(-51.013 -96.891)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081",
    transform: "translate(104.707 158.977)",
    opacity: 0.2,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5080",
    "data-name": "Group 5080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5079",
    "data-name": "Group 5079",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5078",
    "data-name": "Group 5078",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5077",
    "data-name": "Group 5077",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    width: 788.368,
    height: 455.165,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5084",
    "data-name": "Group 5084",
    transform: "translate(229.219 234.416)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5083",
    "data-name": "Group 5083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13959",
    "data-name": "Path 13959",
    d: "M381.354,425.6,111.676,269.9l269.67-155.693,269.678,155.7Z",
    transform: "translate(-111.678 -114.209)",
    fill: "#53a5f8"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13960",
    "data-name": "Path 13960",
    d: "M381.045,425.122a9.674,9.674,0,0,1-4.838-1.293l-262.917-151.8a2.648,2.648,0,0,1,0-4.585L376.2,115.659a9.684,9.684,0,0,1,9.68,0L648.8,267.454a2.647,2.647,0,0,1,0,4.583L385.887,423.829a9.684,9.684,0,0,1-4.842,1.293m-3.811-3.068a7.665,7.665,0,0,0,7.627,0L647.772,270.262a.6.6,0,0,0,0-1.032l-262.919-151.8a7.645,7.645,0,0,0-7.627,0L114.317,269.224a.6.6,0,0,0,0,1.034Z",
    transform: "translate(117.847 120.368)",
    fill: "url(#linear-gradient)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5087",
    "data-name": "Group 5087",
    transform: "translate(183.921 308.372)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5086",
    "data-name": "Group 5086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5085",
    "data-name": "Group 5085",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13961",
    "data-name": "Path 13961",
    d: "M157.571,437.21l-1.026-1.775,1.78-1.026,1.026,1.775Zm8.688-5.016-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.016-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.014-1.026-1.777,1.777-1.026,1.026,1.777Zm8.688-5.018-1.026-1.776,1.778-1.026,1.026,1.775Zm8.688-5.014-1.026-1.775,1.778-1.026,1.026,1.775Zm8.688-5.016-1.026-1.777,1.775-1.026,1.026,1.777Zm8.686-5.016-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.014-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.016-1.026-1.777,1.777-1.026,1.026,1.777Zm8.688-5.016-1.026-1.775,1.777-1.026,1.026,1.775Zm8.325-6.439-1.95-.638a3.614,3.614,0,0,0,.179-1.119,3.871,3.871,0,0,0-.029-.46l2.036-.259a6.037,6.037,0,0,1,.045.718,5.6,5.6,0,0,1-.281,1.757m-6.818-6.718-1.775-1.026,1.026-1.775,1.775,1.026Zm-8.688-5.014-1.775-1.026,1.026-1.775L238.3,367.1Zm-8.688-5.018-1.775-1.026,1.026-1.775,1.775,1.026Zm-8.688-5.014-1.775-1.026,1.026-1.775,1.775,1.026Zm-8.686-5.016L209.43,352.8l1.026-1.777,1.777,1.026Zm-8.688-5.016-1.777-1.026,1.026-1.775,1.777,1.026Zm-8.688-5.016-1.777-1.026L193.079,341l1.777,1.026Zm394.631-3.465q-.5,0-1.01-.031l.119-2.048c.324.016.649.033.977.027s.642-.01.963-.027l.107,2.048c-.384.023-.776.031-1.156.031m-403.319-1.55-1.777-1.026,1.026-1.777,1.777,1.026Zm412.535-.718-.971-1.808c.191-.1.38-.2.564-.31l1.19-.688,1.026,1.775-1.19.688c-.205.119-.413.232-.62.343m-18.272-.012c-.2-.107-.4-.216-.6-.33l-1.219-.706,1.026-1.775,1.221.706c.179.1.355.2.53.293Zm-402.952-4.286-1.777-1.026,1.026-1.775,1.777,1.026Zm429.944-.723-1.026-1.775,1.777-1.026,1.026,1.775Zm-35.718-.016L568.9,332l1.026-1.775,1.777,1.026Zm-402.913-4.277-1.78-1.026,1.026-1.775,1.78,1.026Zm447.319-.723-1.026-1.775,1.777-1.026L616.864,327Zm-53.1-.016-1.778-1.026,1.026-1.777,1.777,1.026Zm-402.911-4.275-1.777-1.026,1.026-1.777,1.777,1.026Zm464.7-.725-1.026-1.775,1.777-1.026,1.026,1.775ZM553.3,323l-1.777-1.026,1.026-1.775,1.777,1.026Zm-402.913-4.277-1.777-1.026,1.026-1.775,1.777,1.026Zm482.07-.72-1.026-1.777,1.78-1.026,1.026,1.777Zm-87.846-.018-1.777-1.026,1.026-1.775,1.777,1.026ZM141.7,313.7l-1.777-1.026,1.026-1.775,1.777,1.026Zm499.448-.725-1.026-1.775,1.775-1.026,1.026,1.775Zm-105.224-.014-1.778-1.026,1.026-1.777,1.778,1.026Zm-402.913-4.277-1.777-1.026,1.026-1.777,1.777,1.026Zm516.823-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm-118.777-2.6-2.04-.2a5.64,5.64,0,0,1,.79-2.365l1.751,1.071a3.547,3.547,0,0,0-.5,1.5m-406.734-1.7-1.777-1.026,1.026-1.775,1.777,1.026Zm534.2-.722-1.026-1.778,1.775-1.026,1.026,1.778Zm-120.768-3.14-1.026-1.775,1.777-1.026,1.026,1.775Zm-422.12-1.154-1.78-1.026,1.026-1.775,1.78,1.026Zm551.574-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm-120.768-3.138-1.026-1.775,1.777-1.026,1.026,1.775Zm-439.495-1.154-1.78-1.026,1.026-1.777,1.78,1.026Zm568.949-.725-1.026-1.775,1.78-1.026,1.026,1.775Zm-120.764-3.138L554.11,288l1.776-1.026,1.026,1.777ZM98.263,288.623,96.486,287.6l1.026-1.775,1.777,1.026Zm586.327-.72-1.026-1.777,1.777-1.026,1.026,1.777Zm-120.768-3.14-1.026-1.775,1.778-1.026,1.026,1.775Zm129.454-1.878-1.026-1.775,1.777-1.026,1.026,1.775ZM89.91,282.223a5.67,5.67,0,0,1-.265-2.471l2.038.232a4.007,4.007,0,0,0-.023.415,3.569,3.569,0,0,0,.191,1.16Zm482.6-2.477-1.026-1.775,1.779-1.026,1.026,1.775Zm129.458-1.876-1.026-1.775,1.775-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm484.541-.737-1.026-1.777,1.777-1.026,1.026,1.777Zm-299.525-1.057-.3-2.028a18.222,18.222,0,0,0,1.9-.392l.521,1.985a19.18,19.18,0,0,1-2.118.435m-8.339-.575a19.912,19.912,0,0,1-2.04-.723l.79-1.9a18.148,18.148,0,0,0,1.829.651Zm437.319-.246-1.026-1.777,1.777-1.026,1.026,1.777Zm-605.309-2.4-1.026-1.777,1.78-1.026,1.026,1.777Zm185.884-.723-1.026-1.775,1.777-1.026,1.026,1.775Zm298.657-.018-1.026-1.775,1.778-1.026,1.026,1.775ZM264.2,268.461l-1.777-1.026,1.026-1.775,1.777,1.026Zm455.145-.624-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.779-1.026,1.026,1.775Zm185.884-.718-1.026-1.778,1.778-1.026,1.026,1.778Zm298.661-.018-1.03-1.775,1.775-1.028,1.03,1.775Zm-343.067-1.252-1.78-1.026,1.026-1.777,1.78,1.026Zm472.519-.626L727,261.045l1.777-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.884-.723-1.026-1.775,1.775-1.026,1.026,1.775Zm298.657-.016-1.026-1.777,1.777-1.026,1.026,1.777Zm-360.44-1.254-1.777-1.026,1.026-1.775,1.777,1.026Zm489.894-.622-1.026-1.777L737.47,255l1.026,1.777ZM131.41,255.4l-1.026-1.778,1.777-1.026,1.026,1.777Zm185.884-.72-1.026-1.775,1.775-1.026,1.026,1.775Zm298.655-.021-1.026-1.775,1.78-1.026,1.026,1.775Zm-377.814-1.25-1.777-1.026,1.026-1.775,1.777,1.026Zm507.273-.626-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.882-.72-1.026-1.777,1.777-1.026,1.026,1.777Zm298.659-.018-1.026-1.775,1.778-1.026,1.026,1.775ZM229.446,248.4l-1.778-1.026,1.026-1.777,1.777,1.026Zm524.647-.624L753.067,246l1.777-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.78-1.026,1.026,1.775Zm185.884-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm298.657-.018-1.026-1.777,1.778-1.026,1.026,1.777Zm-412.568-1.252-1.777-1.026,1.026-1.775,1.777,1.026Zm542.026-.624-1.026-1.775,1.778-1.026,1.026,1.775Zm-605.311-2.4-1.026-1.777,1.78-1.026,1.026,1.777Zm185.884-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm298.661-.018-1.03-1.775.314-.183a3.613,3.613,0,0,0,1-.846l1.6,1.291a5.649,5.649,0,0,1-1.562,1.33Zm-429.948-1.252-1.777-1.026,1.026-1.775,1.777,1.026Zm559.4-.624-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.78-1.026,1.026,1.775Zm185.884-.72-1.026-1.777,1.777-1.026,1.026,1.777Zm-148.662-1.273-1.78-1.026,1.026-1.775,1.78,1.026Zm576.775-.622-1.026-1.775,1.777-1.026,1.026,1.775Zm-138.941-1.25-1.777-1.026,1.026-1.775,1.777,1.026Zm-466.368-1.152-1.026-1.775,1.777-1.026,1.026,1.775Zm185.884-.72-1.026-1.775,1.778-1.026,1.026,1.775Zm-166.016-1.246a17.2,17.2,0,0,0-1.755-.821l.761-1.9a19.506,19.506,0,0,1,1.962.913Zm594.129-.651-1.026-1.775,1.777-1.026,1.026,1.775ZM183.66,226.532l-.337-2.024a18.623,18.623,0,0,1,2.157-.232l.1,2.048a16.386,16.386,0,0,0-1.923.207m448.87-.07-1.78-1.026,1.026-1.775,1.78,1.026Zm-263.112-1.874-1.026-1.775,1.777-1.026,1.026,1.775Zm428.113-1.894-1.026-1.775,1.777-1.026,1.026,1.775ZM623.84,221.446l-1.775-1.026,1.026-1.777,1.775,1.026Zm-245.731-1.872-1.026-1.777,1.777-1.026,1.026,1.777Zm428.113-1.9L805.2,215.9l1.778-1.026L808,216.651Zm-191.068-1.248-1.778-1.026,1.026-1.775,1.777,1.026ZM386.8,214.556l-1.026-1.775,1.778-1.026,1.026,1.775Zm428.113-1.894-1.026-1.775,1.777-1.026,1.026,1.775Zm-208.445-1.248-1.776-1.026,1.026-1.775,1.776,1.026Zm-210.98-1.872-1.026-1.775,1.777-1.026,1.026,1.775ZM597.778,206.4,596,205.373l1.026-1.777,1.777,1.026Zm-193.605-1.874-1.026-1.777,1.777-1.026,1.026,1.777Zm184.917-3.144-1.778-1.026,1.026-1.775,1.778,1.026ZM412.86,199.509l-1.026-1.775,1.775-1.026,1.026,1.775ZM580.4,196.366l-1.778-1.026,1.026-1.775,1.778,1.026Zm-158.852-1.874-1.026-1.775,1.777-1.026,1.026,1.775Zm150.166-3.142-1.779-1.026,1.026-1.777,1.78,1.026Zm-141.48-1.874-1.026-1.775,1.777-1.026,1.026,1.775Zm132.789-3.142-1.777-1.026,1.026-1.775,1.777,1.026Zm-124.1-1.874-1.026-1.775,1.78-1.026,1.026,1.775Zm115.415-3.142-1.778-1.026,1.026-1.775,1.778,1.026Zm-106.727-1.872-1.026-1.775,1.777-1.026,1.026,1.775Zm98.036-3.142-1.775-1.026L544.9,173.5l1.775,1.026ZM456.3,174.427l-1.026-1.775,1.78-1.026,1.026,1.775Zm80.662-3.142-1.777-1.026,1.026-1.775,1.777,1.026Zm-71.973-1.872-1.026-1.775,1.777-1.026,1.026,1.775Zm63.287-3.142-1.779-1.026,1.026-1.775,1.779,1.026Zm-54.6-1.874-1.026-1.775,1.775-1.026,1.026,1.775Zm45.909-3.142-1.778-1.026,1.026-1.775,1.777,1.026Zm-37.22-1.874-1.026-1.775,1.777-1.026,1.026,1.775Zm28.534-3.142-1.778-1.026,1.026-1.775,1.778,1.026Zm-19.868-1.853-.977-1.8a19.3,19.3,0,0,1,1.956-.926l.774,1.9a17.47,17.47,0,0,0-1.753.829m11.049-1.9a18.383,18.383,0,0,0-1.929-.2l.1-2.048a19.371,19.371,0,0,1,2.153.22Z",
    transform: "translate(-89.607 -150.242)",
    fill: "#73cffe"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13962",
    "data-name": "Path 13962",
    d: "M157.571,426.888l-1.026-1.775,1.78-1.026,1.026,1.775Zm8.688-5.018-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.014-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.016-1.026-1.777,1.777-1.026,1.026,1.777Zm8.688-5.016-1.026-1.775,1.778-1.026L194.1,405.8Zm8.688-5.016-1.026-1.775L201.764,399l1.026,1.775Zm8.686-5.014-1.026-1.777,1.78-1.026,1.026,1.777Zm8.688-5.018L217.361,390l1.777-1.026,1.026,1.775Zm8.688-5.014-1.026-1.775,1.777-1.026,1.026,1.775Zm8.688-5.016-1.026-1.777,1.777-1.026,1.026,1.777Zm8.686-5.016-1.026-1.775,1.78-1.026,1.026,1.775Zm8.329-6.439-1.952-.636a3.567,3.567,0,0,0,.179-1.121,3.446,3.446,0,0,0-.029-.458l2.036-.259a5.547,5.547,0,0,1,.045.716,5.639,5.639,0,0,1-.279,1.757m-6.82-6.716-1.775-1.026,1.026-1.775,1.775,1.026Zm-8.688-5.014-1.775-1.026,1.026-1.775,1.775,1.026Zm-8.686-5.018-1.777-1.026,1.026-1.776,1.777,1.026Zm-8.688-5.014-1.777-1.026,1.026-1.775,1.777,1.026Zm-8.688-5.016-1.778-1.026,1.026-1.777,1.777,1.026Zm-8.688-5.016-1.777-1.026,1.026-1.775,1.777,1.026Zm-8.688-5.016-1.775-1.026,1.026-1.775,1.775,1.026Zm394.631-3.465q-.5,0-1.01-.031l.119-2.048c.326.016.649.033.977.027s.642-.01.959-.027l.111,2.048c-.384.023-.774.025-1.156.031m-403.317-1.55-1.777-1.026,1.026-1.778,1.778,1.026Zm412.531-.718-.969-1.808,1.755-1,1.026,1.775Zm-18.269-.014c-.2-.107-.4-.216-.6-.331l-1.219-.7,1.026-1.78,1.221.7c.179.1.355.2.532.3Zm-402.949-4.286-1.777-1.026,1.026-1.775,1.778,1.026Zm429.942-.72-1.026-1.775,1.777-1.026,1.026,1.775ZM570.68,322.7l-1.777-1.026,1.026-1.775,1.777,1.026Zm-402.913-4.275L165.99,317.4l1.026-1.775,1.777,1.026Zm447.319-.724-1.026-1.776,1.777-1.026,1.026,1.775Zm-53.094-.014-1.78-1.026,1.026-1.778,1.779,1.026Zm-402.913-4.277-1.777-1.026,1.026-1.777,1.777,1.026Zm464.7-.722-1.026-1.775,1.775-1.026,1.026,1.775Zm-70.471-.018-1.777-1.026,1.026-1.775,1.777,1.026ZM150.391,308.4l-1.777-1.026,1.026-1.775,1.777,1.026Zm482.07-.722-1.026-1.777,1.78-1.026,1.026,1.777Zm-87.846-.016-1.777-1.026,1.026-1.775,1.777,1.026ZM141.7,303.38l-1.777-1.026,1.026-1.775,1.777,1.026Zm499.446-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm-105.222-.014-1.778-1.026,1.026-1.777,1.778,1.026Zm-402.911-4.277-1.777-1.026,1.026-1.778,1.777,1.026Zm516.821-.725-1.026-1.775,1.777-1.026,1.026,1.775Zm-118.779-2.594-2.04-.2a5.632,5.632,0,0,1,.79-2.364l1.751,1.071a3.607,3.607,0,0,0-.5,1.5m-406.73-1.7-1.777-1.026,1.026-1.775,1.777,1.026Zm534.2-.72L657.5,290.85l1.778-1.026L660.3,291.6Zm-120.768-3.14-1.026-1.775,1.777-1.026,1.026,1.775ZM115.64,288.333l-1.777-1.026,1.026-1.775,1.777,1.026Zm551.574-.725-1.026-1.775,1.775-1.026,1.026,1.775ZM546.446,284.47l-1.026-1.775,1.775-1.026,1.026,1.775Zm-439.495-1.154-1.777-1.026,1.026-1.777,1.777,1.026Zm568.951-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm-120.768-3.138-1.026-1.777,1.778-1.026,1.026,1.777ZM98.263,278.3l-1.777-1.026,1.026-1.775,1.777,1.026Zm586.327-.723-1.026-1.777,1.775-1.026,1.026,1.777Zm-120.768-3.14-1.026-1.775,1.776-1.026,1.026,1.775Zm129.454-1.876-1.026-1.775,1.78-1.026,1.026,1.775ZM89.912,271.9a5.652,5.652,0,0,1-.267-2.473l2.038.232a4.006,4.006,0,0,0-.023.415,3.629,3.629,0,0,0,.193,1.162Zm482.6-2.479-1.026-1.775,1.777-1.026,1.026,1.775Zm129.454-1.878-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.307-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm484.539-.739-1.026-1.777,1.777-1.026,1.026,1.777Zm-299.523-1.055-.3-2.028a18.363,18.363,0,0,0,1.9-.392l.519,1.985a19.187,19.187,0,0,1-2.118.435m-8.337-.575a19.921,19.921,0,0,1-2.04-.723l.79-1.9a17.782,17.782,0,0,0,1.829.651Zm437.317-.246-1.026-1.778,1.777-1.026,1.026,1.777Zm-605.307-2.4-1.026-1.777,1.777-1.026,1.026,1.777Zm185.882-.722-1.026-1.775,1.777-1.026,1.026,1.775Zm298.657-.018-1.026-1.775,1.779-1.026,1.026,1.775ZM264.2,258.141l-1.777-1.026,1.026-1.775,1.777,1.026Zm455.143-.628-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.307-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.882-.718-1.026-1.775,1.778-1.026,1.026,1.775Zm298.657-.021-1.026-1.775,1.778-1.026,1.026,1.775Zm-343.063-1.25-1.777-1.026,1.026-1.778,1.777,1.026ZM728.03,252.5,727,250.723l1.775-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.78-1.026,1.026,1.775Zm185.884-.723-1.026-1.775,1.777-1.026,1.026,1.775Zm298.657-.016-1.026-1.777,1.777-1.026,1.026,1.777Zm-360.44-1.252-1.777-1.026,1.026-1.775,1.777,1.026Zm489.894-.626L735.69,245.7l1.779-1.026,1.026,1.778Zm-605.307-2.4-1.026-1.777,1.78-1.026,1.026,1.778Zm185.884-.72-1.026-1.775,1.777-1.026,1.026,1.775Zm298.657-.021-1.026-1.775,1.777-1.026,1.026,1.775Zm-377.817-1.25-1.777-1.026,1.026-1.775,1.777,1.026Zm507.273-.626-1.026-1.775,1.775-1.026,1.026,1.775Zm-605.309-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.884-.72-1.026-1.777,1.777-1.026,1.026,1.777Zm298.657-.018-1.026-1.775,1.775-1.026,1.026,1.775Zm-395.191-1.25-1.78-1.026,1.026-1.777,1.78,1.026Zm524.645-.628-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.307-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.884-.72-1.026-1.775,1.777-1.026,1.026,1.775Zm298.655-.018-1.026-1.777,1.78-1.026,1.026,1.777ZM220.76,233.059l-1.777-1.026,1.026-1.775,1.777,1.026Zm542.022-.624-1.026-1.777,1.777-1.026,1.026,1.777Zm-605.307-2.4-1.026-1.777,1.777-1.026,1.026,1.777Zm185.884-.722-1.026-1.775,1.775-1.026,1.026,1.775Zm298.659-.018-1.03-1.775.314-.183a3.52,3.52,0,0,0,1-.844l1.595,1.291a5.62,5.62,0,0,1-1.564,1.33Zm-429.946-1.25-1.777-1.026,1.026-1.775,1.777,1.026Zm559.4-.628-1.026-1.775,1.777-1.026,1.026,1.775Zm-605.307-2.4-1.026-1.775,1.777-1.026,1.026,1.775Zm185.882-.718-1.026-1.777L352.8,221.5l1.026,1.778Zm-148.662-1.273L201.605,222l1.026-1.775,1.777,1.026Zm576.773-.624-1.026-1.775,1.78-1.026,1.026,1.775Zm-138.939-1.248-1.775-1.026,1.026-1.775,1.775,1.026ZM174.851,220l-1.026-1.775L175.6,217.2l1.026,1.775Zm185.882-.723-1.026-1.775,1.778-1.026,1.026,1.775Zm-166.013-1.244a17.252,17.252,0,0,0-1.757-.821l.761-1.9a19.513,19.513,0,0,1,1.962.913Zm594.127-.651-1.026-1.777,1.777-1.026,1.026,1.777Zm-605.184-1.178-.337-2.024a18.57,18.57,0,0,1,2.157-.232l.1,2.048a16.819,16.819,0,0,0-1.921.207m448.868-.068-1.777-1.026,1.026-1.775,1.777,1.026Zm-263.11-1.874-1.026-1.775,1.775-1.026,1.026,1.775Zm428.111-1.9-1.026-1.775,1.777-1.026,1.026,1.775Zm-173.69-1.246-1.777-1.026,1.026-1.777,1.777,1.026ZM378.109,209.25l-1.026-1.778,1.777-1.026,1.026,1.777Zm428.113-1.9-1.026-1.775,1.775-1.026L808,206.327Zm-191.068-1.246-1.778-1.026,1.026-1.775,1.777,1.026ZM386.8,204.234l-1.026-1.775,1.776-1.026,1.026,1.775Zm428.111-1.9-1.026-1.775,1.777-1.026,1.026,1.775Zm-208.441-1.244-1.78-1.026,1.026-1.775,1.78,1.026Zm-210.982-1.876-1.026-1.775,1.777-1.026,1.026,1.775Zm202.292-3.14L596,195.051l1.026-1.777L598.8,194.3ZM404.172,194.2l-1.026-1.777,1.777-1.026,1.026,1.777Zm184.919-3.142-1.78-1.026,1.026-1.775,1.78,1.026ZM412.86,189.185l-1.026-1.775,1.78-1.026,1.026,1.775Zm167.541-3.14-1.775-1.026,1.026-1.775,1.776,1.026ZM421.549,184.17l-1.026-1.775,1.777-1.026,1.026,1.775Zm150.166-3.14L569.937,180l1.026-1.777,1.777,1.026Zm-141.478-1.876-1.026-1.777,1.777-1.026,1.026,1.777Zm132.789-3.142-1.777-1.026,1.026-1.775,1.777,1.026Zm-124.1-1.874-1.026-1.775,1.78-1.026,1.026,1.775ZM554.338,171l-1.778-1.026,1.026-1.775,1.778,1.026Zm-106.725-1.876-1.026-1.775,1.775-1.026,1.026,1.775Zm98.038-3.14-1.779-1.026,1.026-1.777,1.779,1.026ZM456.3,164.1l-1.026-1.775,1.78-1.026,1.026,1.775Zm80.662-3.14-1.777-1.026,1.026-1.775,1.777,1.026Zm-71.973-1.876-1.026-1.775,1.777-1.026,1.026,1.775Zm63.287-3.14-1.777-1.026,1.026-1.775,1.777,1.026Zm-54.6-1.874L472.65,152.3l1.777-1.026,1.026,1.775Zm45.909-3.142-1.776-1.026,1.026-1.775,1.776,1.026Zm-37.22-1.874-1.026-1.775,1.777-1.026,1.026,1.775Zm28.534-3.142-1.778-1.026,1.026-1.775,1.778,1.026Zm-19.868-1.853-.977-1.8a19.3,19.3,0,0,1,1.956-.926l.774,1.9a18.144,18.144,0,0,0-1.753.829m11.051-1.9a18.36,18.36,0,0,0-1.927-.2l.1-2.048a19.393,19.393,0,0,1,2.151.22Z",
    transform: "translate(94.314 147.266)",
    fill: "#73cffe"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5193",
    "data-name": "Group 5193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5192",
    "data-name": "Group 5192",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5105",
    "data-name": "Group 5105",
    transform: "translate(428.655 188.716)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5104",
    "data-name": "Group 5104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5103",
    "data-name": "Group 5103",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13972",
    "data-name": "Path 13972",
    d: "M212.681,91.944a19.9,19.9,0,0,1-3.838.513c1.184-.185,2.6-.388,3.838-.513",
    transform: "translate(-208.845 -91.944)",
    fill: "#e28c61"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5113",
    "data-name": "Group 5113",
    transform: "translate(221.394 154.094)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5112",
    "data-name": "Group 5112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5111",
    "data-name": "Group 5111",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13981",
    "data-name": "Path 13981",
    d: "M125.45,11.739V32.6L107.865,22.168Z",
    transform: "translate(-107.866 -11.739)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13982",
    "data-name": "Path 13982",
    d: "M132.13,32.6V11.739l17.586,10.429Z",
    transform: "translate(-82.326 -11.739)",
    fill: "#fbb516"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13983",
    "data-name": "Path 13983",
    d: "M119.2,24.669h20.858L129.629,42.255Z",
    transform: "translate(125.46 155.965)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5116",
    "data-name": "Group 5116",
    transform: "translate(244.66 130.829)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5115",
    "data-name": "Group 5115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5114",
    "data-name": "Group 5114",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13984",
    "data-name": "Path 13984",
    d: "M140.058,17.99H119.2L129.629.4Z",
    transform: "translate(-119.2 -0.404)",
    fill: "#fbb516"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13986",
    "data-name": "Path 13986",
    d: "M230.944,162.4a2.493,2.493,0,1,1-3.4-.924,2.495,2.495,0,0,1,3.4.924",
    transform: "translate(238.172 169.611)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5122",
    "data-name": "Group 5122",
    transform: "translate(471.434 326.762)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5121",
    "data-name": "Group 5121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5120",
    "data-name": "Group 5120",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13987",
    "data-name": "Path 13987",
    d: "M234.342,160.455a2.492,2.492,0,1,1-3.4-.924,2.492,2.492,0,0,1,3.4.924",
    transform: "translate(-229.685 -159.201)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5125",
    "data-name": "Group 5125",
    transform: "translate(478.408 322.768)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5124",
    "data-name": "Group 5124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5123",
    "data-name": "Group 5123",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13988",
    "data-name": "Path 13988",
    d: "M237.739,158.508a2.492,2.492,0,1,1-3.4-.924,2.492,2.492,0,0,1,3.4.924",
    transform: "translate(-233.084 -157.256)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5128",
    "data-name": "Group 5128",
    transform: "translate(485.383 318.772)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5127",
    "data-name": "Group 5127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5126",
    "data-name": "Group 5126",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13989",
    "data-name": "Path 13989",
    d: "M241.137,156.562a2.492,2.492,0,1,1-3.4-.924,2.492,2.492,0,0,1,3.4.924",
    transform: "translate(-236.482 -155.308)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5131",
    "data-name": "Group 5131",
    transform: "translate(492.355 314.776)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5130",
    "data-name": "Group 5130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5129",
    "data-name": "Group 5129",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13990",
    "data-name": "Path 13990",
    d: "M244.534,154.615a2.493,2.493,0,1,1-3.4-.924,2.492,2.492,0,0,1,3.4.924",
    transform: "translate(-239.879 -153.361)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13991",
    "data-name": "Path 13991",
    d: "M226.619,164.88a2.493,2.493,0,1,0,.924-3.4,2.492,2.492,0,0,0-.924,3.4",
    transform: "translate(238.173 169.61)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5134",
    "data-name": "Group 5134",
    transform: "translate(457.487 334.755)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5133",
    "data-name": "Group 5133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5132",
    "data-name": "Group 5132",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13992",
    "data-name": "Path 13992",
    d: "M223.221,166.827a2.492,2.492,0,1,0,.924-3.4,2.493,2.493,0,0,0-.924,3.4",
    transform: "translate(-222.891 -163.095)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5137",
    "data-name": "Group 5137",
    transform: "translate(450.514 338.749)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5136",
    "data-name": "Group 5136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5135",
    "data-name": "Group 5135",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13993",
    "data-name": "Path 13993",
    d: "M219.823,168.774a2.492,2.492,0,1,0,.924-3.4,2.493,2.493,0,0,0-.924,3.4",
    transform: "translate(-219.494 -165.04)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5140",
    "data-name": "Group 5140",
    transform: "translate(443.54 342.745)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5139",
    "data-name": "Group 5139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5138",
    "data-name": "Group 5138",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13994",
    "data-name": "Path 13994",
    d: "M216.426,170.72a2.492,2.492,0,1,0,.924-3.4,2.492,2.492,0,0,0-.924,3.4",
    transform: "translate(-216.096 -166.988)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5143",
    "data-name": "Group 5143",
    transform: "translate(436.566 346.741)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5142",
    "data-name": "Group 5142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5141",
    "data-name": "Group 5141",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13995",
    "data-name": "Path 13995",
    d: "M213.029,172.667a2.492,2.492,0,1,0,.924-3.4,2.493,2.493,0,0,0-.924,3.4",
    transform: "translate(-212.698 -168.935)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13996",
    "data-name": "Path 13996",
    d: "M232.277,239.058a4.952,4.952,0,0,1-4.481,0,1.366,1.366,0,0,1,0-2.586,4.965,4.965,0,0,1,4.481,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(238.785 248.328)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5146",
    "data-name": "Group 5146",
    transform: "translate(472.875 488.433)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5145",
    "data-name": "Group 5145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5144",
    "data-name": "Group 5144",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13997",
    "data-name": "Path 13997",
    d: "M235.794,241.089a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-230.387 -237.967)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5149",
    "data-name": "Group 5149",
    transform: "translate(480.095 492.601)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5148",
    "data-name": "Group 5148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5147",
    "data-name": "Group 5147",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13998",
    "data-name": "Path 13998",
    d: "M239.312,243.119a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-233.905 -239.999)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5152",
    "data-name": "Group 5152",
    transform: "translate(487.316 496.77)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5151",
    "data-name": "Group 5151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5150",
    "data-name": "Group 5150",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13999",
    "data-name": "Path 13999",
    d: "M242.829,245.15a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(-237.425 -242.03)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155",
    transform: "translate(494.535 500.938)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5154",
    "data-name": "Group 5154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5153",
    "data-name": "Group 5153",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14000",
    "data-name": "Path 14000",
    d: "M246.347,247.182a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.948,4.948,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-240.94 -244.061)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14001",
    "data-name": "Path 14001",
    d: "M241.137,233.942a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(248.111 242.943)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5158",
    "data-name": "Group 5158",
    transform: "translate(491.062 477.932)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5157",
    "data-name": "Group 5157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5156",
    "data-name": "Group 5156",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14002",
    "data-name": "Path 14002",
    d: "M244.655,235.973a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-239.249 -232.851)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5161",
    "data-name": "Group 5161",
    transform: "translate(498.283 482.101)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5160",
    "data-name": "Group 5160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5159",
    "data-name": "Group 5159",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14003",
    "data-name": "Path 14003",
    d: "M248.172,238a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(-242.768 -234.882)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5164",
    "data-name": "Group 5164",
    transform: "translate(505.501 486.269)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5163",
    "data-name": "Group 5163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5162",
    "data-name": "Group 5162",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14004",
    "data-name": "Path 14004",
    d: "M251.69,240.035a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-246.284 -236.913)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5167",
    "data-name": "Group 5167",
    transform: "translate(512.722 490.438)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5166",
    "data-name": "Group 5166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5165",
    "data-name": "Group 5165",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14005",
    "data-name": "Path 14005",
    d: "M255.208,242.066a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(-249.802 -238.944)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14006",
    "data-name": "Path 14006",
    d: "M259.547,103.469a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(267.487 105.618)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5170",
    "data-name": "Group 5170",
    transform: "translate(528.849 210.136)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5169",
    "data-name": "Group 5169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5168",
    "data-name": "Group 5168",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14007",
    "data-name": "Path 14007",
    d: "M263.064,105.5a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-257.659 -102.38)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5173",
    "data-name": "Group 5173",
    transform: "translate(536.067 214.305)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5172",
    "data-name": "Group 5172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5171",
    "data-name": "Group 5171",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14008",
    "data-name": "Path 14008",
    d: "M266.582,107.531a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(-261.175 -104.411)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5176",
    "data-name": "Group 5176",
    transform: "translate(543.288 218.472)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5174",
    "data-name": "Group 5174",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14009",
    "data-name": "Path 14009",
    d: "M270.1,109.562a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-264.693 -106.44)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179",
    transform: "translate(550.509 222.64)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5178",
    "data-name": "Group 5178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5177",
    "data-name": "Group 5177",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14010",
    "data-name": "Path 14010",
    d: "M273.617,111.593a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(-268.213 -108.471)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14011",
    "data-name": "Path 14011",
    d: "M268.407,98.354a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.366,1.366,0,0,1,0,2.586",
    transform: "translate(276.813 100.235)",
    fill: "#81dafe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5182",
    "data-name": "Group 5182",
    transform: "translate(547.034 199.636)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5181",
    "data-name": "Group 5181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5180",
    "data-name": "Group 5180",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14012",
    "data-name": "Path 14012",
    d: "M271.925,100.385a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-266.519 -97.263)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185",
    transform: "translate(554.255 203.804)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5184",
    "data-name": "Group 5184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5183",
    "data-name": "Group 5183",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14013",
    "data-name": "Path 14013",
    d: "M275.443,102.415a4.948,4.948,0,0,1-4.478,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.478,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-270.036 -99.295)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188",
    transform: "translate(561.475 207.973)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5187",
    "data-name": "Group 5187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5186",
    "data-name": "Group 5186",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14014",
    "data-name": "Path 14014",
    d: "M278.96,104.446a4.948,4.948,0,0,1-4.479,0,1.365,1.365,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-273.555 -101.326)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5191",
    "data-name": "Group 5191",
    transform: "translate(568.694 212.142)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5190",
    "data-name": "Group 5190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14015",
    "data-name": "Path 14015",
    d: "M282.478,106.477a4.948,4.948,0,0,1-4.479,0,1.366,1.366,0,0,1,0-2.586,4.961,4.961,0,0,1,4.479,0,1.365,1.365,0,0,1,0,2.586",
    transform: "translate(-277.071 -103.357)",
    fill: "#81dafe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14016",
    "data-name": "Path 14016",
    d: "M355.571,109.595a6.756,6.756,0,1,1-6.757-6.757,6.757,6.757,0,0,1,6.757,6.757",
    transform: "translate(360.022 108.238)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14017",
    "data-name": "Path 14017",
    d: "M370.509,109.595a6.756,6.756,0,1,1-6.757-6.757,6.757,6.757,0,0,1,6.757,6.757",
    transform: "translate(375.744 108.238)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14018",
    "data-name": "Path 14018",
    d: "M363.04,98.032a6.756,6.756,0,1,1-6.757-6.757,6.757,6.757,0,0,1,6.757,6.757",
    transform: "translate(367.883 96.068)",
    fill: "#fbb516"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5251",
    "data-name": "Group 5251",
    transform: "translate(353 203.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14036",
    "data-name": "Path 14036",
    d: "M41.16,130.339l3.677-2.12-26.4-15.245-3.677,2.12Z",
    transform: "translate(3.144 24.073)",
    fill: "#e3a05d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14037",
    "data-name": "Path 14037",
    d: "M15.095,107.764l3.677-2.12v9.13l-3.677,2.12Z",
    transform: "translate(3.217 22.511)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14038",
    "data-name": "Path 14038",
    d: "M42.3,129.448l2.208-1.271L18.514,113.17,16.3,114.441Z",
    transform: "translate(3.474 24.115)",
    fill: "#e6d1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14039",
    "data-name": "Path 14039",
    d: "M18.126,81.159v38.832L44.119,135V96.166Zm1.829,3.431L42.077,97.361v34.085L19.955,118.674Z",
    transform: "translate(3.862 17.294)",
    fill: "#704b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14040",
    "data-name": "Path 14040",
    d: "M42.967,130.143,20.845,117.372V83.287L42.967,96.059Z",
    transform: "translate(4.442 17.747)",
    fill: "#76787a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14041",
    "data-name": "Path 14041",
    d: "M19.634,112.233l1.47-.849,22.121,12.773L41.756,125Z",
    transform: "translate(4.184 23.735)",
    fill: "#704332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14042",
    "data-name": "Path 14042",
    d: "M19.634,118.22l1.47-.849V83.287l-1.47.849Z",
    transform: "translate(4.184 17.747)",
    fill: "#493127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14043",
    "data-name": "Path 14043",
    d: "M16.307,82.432l2.208-1.271v38.83l-2.208,1.271Z",
    transform: "translate(3.474 17.294)",
    fill: "#b8977d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14044",
    "data-name": "Path 14044",
    d: "M16.308,106.916l2.208-1.271,0,9.128-2.208,1.271Z",
    transform: "translate(3.474 22.512)",
    fill: "#b8977d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14045",
    "data-name": "Path 14045",
    d: "M0,100.779l2.207,1.273,13.828-7.983-2.207-1.274Z",
    transform: "translate(0 19.774)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14046",
    "data-name": "Path 14046",
    d: "M91.027,83.016,88.82,81.745v38.83l2.208,1.271Z",
    transform: "translate(18.926 17.419)",
    fill: "#b8977d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14047",
    "data-name": "Path 14047",
    d: "M92.5,108.349l-3.677-2.12v9.13l3.677,2.12Z",
    transform: "translate(18.927 22.636)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14048",
    "data-name": "Path 14048",
    d: "M91.027,83.016,88.82,81.745v38.83l2.208,1.271Z",
    transform: "translate(18.926 17.419)",
    fill: "#b8977d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14049",
    "data-name": "Path 14049",
    d: "M64.849,135.24l-3.677-2.12,33.541-19.365,3.677,2.12Z",
    transform: "translate(13.035 24.24)",
    fill: "#e3a05d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14050",
    "data-name": "Path 14050",
    d: "M63.38,134.39l-2.208-1.271,33.539-19.365,2.209,1.271Z",
    transform: "translate(13.035 24.24)",
    fill: "#e6d1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14051",
    "data-name": "Path 14051",
    d: "M112.021,76.773,109.813,75.5V98.074l2.208,1.271Z",
    transform: "translate(23.4 16.089)",
    fill: "#b8977d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14052",
    "data-name": "Path 14052",
    d: "M119.107,86.747l4.536,2.619-2.205,1.273L116.9,88.02Z",
    transform: "translate(24.91 18.485)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14053",
    "data-name": "Path 14053",
    d: "M61.172,101.109v38.832l33.539-19.365V81.744Zm31.71,18.15L63.214,136.388V102.3L92.882,85.175Z",
    transform: "translate(13.035 17.419)",
    fill: "#754f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14054",
    "data-name": "Path 14054",
    d: "M61.644,135.085l29.668-17.129V83.872L61.644,101Z",
    transform: "translate(13.136 17.872)",
    fill: "#76787a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14055",
    "data-name": "Path 14055",
    d: "M92.782,112.818l-1.47-.849L61.644,129.1l1.469.848Z",
    transform: "translate(13.136 23.859)",
    fill: "#704332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14056",
    "data-name": "Path 14056",
    d: "M87.57,118.8l-1.47-.849V83.872l1.47.849Z",
    transform: "translate(18.347 17.872)",
    fill: "#493127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M97.454,118.67l11.4-6.585V77.766l-11.4,6.585Z",
    transform: "translate(20.766 16.571)",
    fill: "#76787a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M110.328,106.906l-1.47-.849-11.4,6.585,1.47.849Z",
    transform: "translate(20.766 22.599)",
    fill: "#704332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M108.325,112.934l-1.47-.849V77.766l1.47.849Z",
    transform: "translate(22.769 16.571)",
    fill: "#493127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14060",
    "data-name": "Path 14060",
    d: "M96.917,84.533V123.6l15.648-9.034V75.5Zm13.526,28.885L99.039,120V85.682l11.4-6.583Z",
    transform: "translate(20.652 16.088)",
    fill: "#754f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14061",
    "data-name": "Path 14061",
    d: "M134.847,42.778v57.23l-10.929,6.31V83.746l-15.645,9.033v22.572l-9.821,5.67v-29.7L64.911,110.685v29.7L53.979,146.7V89.467Z",
    transform: "translate(11.502 9.115)",
    fill: "#f1d7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14062",
    "data-name": "Path 14062",
    d: "M99.921,108.973v9.13L66.381,137.467v-9.13l-12.4,7.161v16.5l55.763-32.2V103.3Z",
    transform: "translate(11.502 22.012)",
    fill: "#c48e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14063",
    "data-name": "Path 14063",
    d: "M125.243,89.955v16.5l-12.4,7.158v-16.5Z",
    transform: "translate(24.046 19.168)",
    fill: "#c48e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14064",
    "data-name": "Path 14064",
    d: "M67.116,129.159,53.98,136.743v-4.869l13.137-7.584Z",
    transform: "translate(11.502 26.485)",
    fill: "#eba96b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14065",
    "data-name": "Path 14065",
    d: "M113.45,97.538v4.869l13.135-7.583V89.955Z",
    transform: "translate(24.175 19.168)",
    fill: "#eba96b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14066",
    "data-name": "Path 14066",
    d: "M102.28,108.521l-9.822,5.671v-4.869l9.822-5.671Z",
    transform: "translate(19.702 22.087)",
    fill: "#eba96b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14067",
    "data-name": "Path 14067",
    d: "M100.461,102.6l-9.822,5.671,2.205,1.273,9.822-5.671Z",
    transform: "translate(19.314 21.863)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14068",
    "data-name": "Path 14068",
    d: "M111.631,96.49l2.207,1.271,13.135-7.583-2.207-1.271Z",
    transform: "translate(23.787 18.945)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14069",
    "data-name": "Path 14069",
    d: "M91.851,112.846l.735.425V108.4l-.735-.425Z",
    transform: "translate(19.572 23.008)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14070",
    "data-name": "Path 14070",
    d: "M1.212,115.873l64.011,36.957v-16.5L44.046,124.107v9.13L18.054,118.23V109.1L1.212,99.377Z",
    transform: "translate(0.258 21.176)",
    fill: "#ab683e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14071",
    "data-name": "Path 14071",
    d: "M57.9,132.805,35.578,119.918v4.869L57.9,137.675Z",
    transform: "translate(7.581 25.553)",
    fill: "#de8745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14072",
    "data-name": "Path 14072",
    d: "M112.843,100.726l.736.423V96.28l-.736-.423Z",
    transform: "translate(24.045 20.426)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14073",
    "data-name": "Path 14073",
    d: "M113.489,96.229l-3.677-2.12,0,16.494,3.676,2.12Z",
    transform: "translate(23.4 20.053)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14074",
    "data-name": "Path 14074",
    d: "M0,104.246l17.575,10.147v-4.869L0,99.377Z",
    transform: "translate(0 21.176)",
    fill: "#de8745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14075",
    "data-name": "Path 14075",
    d: "M37.784,118.869,57.9,130.483l-2.207,1.273L35.578,120.141Z",
    transform: "translate(7.581 25.329)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14076",
    "data-name": "Path 14076",
    d: "M0,99.6l17.575,10.147,2.205-1.273L2.208,98.329Z",
    transform: "translate(0 20.953)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14077",
    "data-name": "Path 14077",
    d: "M65.3,123.24l-13.138,7.585,2.205,1.273L67.5,124.512Z",
    transform: "translate(11.115 26.261)",
    fill: "#ffb774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14078",
    "data-name": "Path 14078",
    d: "M14.489,107.816v4.869l.735-.425v-4.868Z",
    transform: "translate(3.087 22.884)",
    fill: "#b5562a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14079",
    "data-name": "Path 14079",
    d: "M3.636,52.2v57.231L19,118.3V88.6l25.583,14.771v29.7l20.119,11.615V87.459Z",
    transform: "translate(0.775 11.123)",
    fill: "#d9c1ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14080",
    "data-name": "Path 14080",
    d: "M107.074,71.853l-3.233,1.867,3.216,2,3.233-1.867Z",
    transform: "translate(22.127 15.311)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14081",
    "data-name": "Path 14081",
    d: "M114.177,79.79l-3.233,1.866-4.452-6.291,3.233-1.867Z",
    transform: "translate(22.692 15.662)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5206",
    "data-name": "Group 5206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5205",
    "data-name": "Group 5205",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14082",
    "data-name": "Path 14082",
    d: "M113.395,78.685l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(23.474 16.767)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14083",
    "data-name": "Path 14083",
    d: "M109.739,70.315l-3.233,1.866,3.216,2,3.233-1.867Z",
    transform: "translate(22.695 14.983)",
    fill: "#dbe5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5208",
    "data-name": "Group 5208",
    transform: "translate(132.417 87.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5207",
    "data-name": "Group 5207",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1820",
    "data-name": "Rectangle 1820",
    width: 10.735,
    height: 10.909,
    transform: "translate(-3.533 2.04) rotate(-30)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5209",
    "data-name": "Group 5209",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14085",
    "data-name": "Path 14085",
    d: "M116.06,77.146l-3.233,1.868v3.194a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.131,3.131,0,0,0,1.566-2.712Z",
    transform: "translate(24.042 16.439)",
    fill: "#dbe5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14086",
    "data-name": "Path 14086",
    d: "M104.409,73.392l-3.233,1.866,3.216,2,3.233-1.867Z",
    transform: "translate(21.56 15.639)",
    fill: "#dbe5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    "data-name": "Group 5212",
    transform: "translate(125.953 91.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5211",
    "data-name": "Group 5211",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1822",
    "data-name": "Rectangle 1822",
    width: 10.735,
    height: 10.909,
    transform: "translate(-3.533 2.04) rotate(-30)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5213",
    "data-name": "Group 5213",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14088",
    "data-name": "Path 14088",
    d: "M110.73,80.224,107.5,82.091v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(22.906 17.095)",
    fill: "#dbe5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14089",
    "data-name": "Path 14089",
    d: "M112.4,68.776l-3.233,1.867,3.216,2,3.233-1.867Z",
    transform: "translate(23.263 14.655)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14090",
    "data-name": "Path 14090",
    d: "M119.506,76.713l-3.233,1.866-4.451-6.291,3.232-1.867Z",
    transform: "translate(23.828 15.006)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14091",
    "data-name": "Path 14091",
    d: "M118.724,75.608l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(24.61 16.111)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14092",
    "data-name": "Path 14092",
    d: "M101.745,74.93,98.512,76.8l3.216,2,3.233-1.866Z",
    transform: "translate(20.992 15.967)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14093",
    "data-name": "Path 14093",
    d: "M108.848,82.868l-3.233,1.867-4.451-6.292,3.232-1.867Z",
    transform: "translate(21.557 16.317)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14094",
    "data-name": "Path 14094",
    d: "M106.18,84.768l-4.452-6.292-3.216-2.059v7.348a3.727,3.727,0,0,0,1.865,3.228l.51.295a1.374,1.374,0,0,0,2.061-1.19v.228a3.727,3.727,0,0,0,1.865,3.228,2.737,2.737,0,0,0,2.737,0,3.727,3.727,0,0,0,1.865-3.228V82.9Z",
    transform: "translate(20.992 16.284)",
    fill: "#91298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14095",
    "data-name": "Path 14095",
    d: "M70.577,92.927l-3.233,1.867,3.217,2,3.232-1.867Z",
    transform: "translate(14.35 19.802)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14096",
    "data-name": "Path 14096",
    d: "M77.679,100.864l-3.233,1.866L70,96.438l3.232-1.867Z",
    transform: "translate(14.915 20.152)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14097",
    "data-name": "Path 14097",
    d: "M76.9,99.759l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(15.697 21.257)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14098",
    "data-name": "Path 14098",
    d: "M73.241,91.388l-3.233,1.866,3.216,2,3.233-1.866Z",
    transform: "translate(14.918 19.474)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5216",
    "data-name": "Group 5216",
    transform: "translate(88.143 112.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5215",
    "data-name": "Group 5215",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1824",
    "data-name": "Rectangle 1824",
    width: 10.733,
    height: 10.907,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -3.533, 2.039)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    "data-name": "Group 5218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14100",
    "data-name": "Path 14100",
    d: "M79.562,98.22l-3.233,1.867v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(16.265 20.93)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14101",
    "data-name": "Path 14101",
    d: "M67.912,94.465l-3.233,1.866,3.216,2,3.233-1.866Z",
    transform: "translate(13.782 20.129)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220",
    transform: "translate(81.678 116.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1826",
    "data-name": "Rectangle 1826",
    width: 10.734,
    height: 10.908,
    transform: "translate(-3.533 2.04) rotate(-30)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14103",
    "data-name": "Path 14103",
    d: "M74.233,101.3,71,103.164v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(15.129 21.585)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14104",
    "data-name": "Path 14104",
    d: "M75.906,89.85l-3.233,1.867,3.216,2,3.233-1.867Z",
    transform: "translate(15.486 19.146)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14105",
    "data-name": "Path 14105",
    d: "M83.009,97.787l-3.233,1.866-4.451-6.291,3.232-1.867Z",
    transform: "translate(16.051 19.496)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14106",
    "data-name": "Path 14106",
    d: "M82.227,96.682l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(16.833 20.602)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14107",
    "data-name": "Path 14107",
    d: "M81.235,86.773,78,88.639l3.216,2,3.233-1.867Z",
    transform: "translate(16.621 18.49)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14108",
    "data-name": "Path 14108",
    d: "M88.338,94.71l-3.233,1.866-4.452-6.291,3.233-1.867Z",
    transform: "translate(17.186 18.841)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14109",
    "data-name": "Path 14109",
    d: "M87.556,93.6,84.323,95.47v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(17.968 19.946)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14110",
    "data-name": "Path 14110",
    d: "M83.9,85.234,80.667,87.1l3.216,2,3.233-1.867Z",
    transform: "translate(17.189 18.162)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5224",
    "data-name": "Group 5224",
    transform: "translate(101.072 105.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5223",
    "data-name": "Group 5223",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    "data-name": "Rectangle 1828",
    width: 10.734,
    height: 10.908,
    transform: "translate(-3.533 2.04) rotate(-30)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5226",
    "data-name": "Group 5226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5225",
    "data-name": "Group 5225",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14112",
    "data-name": "Path 14112",
    d: "M90.221,92.066l-3.233,1.867v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(18.536 19.618)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14113",
    "data-name": "Path 14113",
    d: "M78.57,88.311l-3.233,1.866,3.216,2,3.233-1.866Z",
    transform: "translate(16.054 18.818)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5228",
    "data-name": "Group 5228",
    transform: "translate(94.608 109.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5227",
    "data-name": "Group 5227",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1830",
    "data-name": "Rectangle 1830",
    width: 10.734,
    height: 10.908,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -3.533, 2.039)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5230",
    "data-name": "Group 5230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5229",
    "data-name": "Group 5229",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14115",
    "data-name": "Path 14115",
    d: "M84.892,95.143,81.659,97.01v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(17.401 20.274)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14116",
    "data-name": "Path 14116",
    d: "M86.564,83.7l-3.233,1.867,3.216,2,3.233-1.867Z",
    transform: "translate(17.757 17.834)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14117",
    "data-name": "Path 14117",
    d: "M93.667,91.633,90.434,93.5l-4.451-6.291,3.232-1.867Z",
    transform: "translate(18.322 18.185)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14118",
    "data-name": "Path 14118",
    d: "M92.885,90.527l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(19.104 19.29)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14119",
    "data-name": "Path 14119",
    d: "M89.229,82.157,86,84.023l3.216,2,3.233-1.866Z",
    transform: "translate(18.325 17.507)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5232",
    "data-name": "Group 5232",
    transform: "translate(107.537 101.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5231",
    "data-name": "Group 5231",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1832",
    "data-name": "Rectangle 1832",
    width: 10.734,
    height: 10.908,
    transform: "translate(-3.533 2.04) rotate(-30)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5234",
    "data-name": "Group 5234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5233",
    "data-name": "Group 5233",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14121",
    "data-name": "Path 14121",
    d: "M95.55,88.989l-3.233,1.867v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(19.672 18.962)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14122",
    "data-name": "Path 14122",
    d: "M91.894,80.618l-3.233,1.867,3.216,2,3.233-1.867Z",
    transform: "translate(18.893 17.179)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14123",
    "data-name": "Path 14123",
    d: "M99,88.556l-3.233,1.866L91.312,84.13l3.233-1.867Z",
    transform: "translate(19.457 17.529)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14124",
    "data-name": "Path 14124",
    d: "M98.215,87.45l-3.233,1.866v3.2a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.712Z",
    transform: "translate(20.24 18.635)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14125",
    "data-name": "Path 14125",
    d: "M65.247,96,62.015,97.87l3.216,2L68.463,98Z",
    transform: "translate(13.215 20.457)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14126",
    "data-name": "Path 14126",
    d: "M72.35,103.941l-3.233,1.867-4.452-6.292L67.9,97.649Z",
    transform: "translate(13.779 20.808)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14127",
    "data-name": "Path 14127",
    d: "M69.683,105.841l-4.452-6.292L62.015,97.49v7.348a3.727,3.727,0,0,0,1.865,3.228l.509.295a1.374,1.374,0,0,0,2.061-1.19v.228a3.727,3.727,0,0,0,1.865,3.228,2.737,2.737,0,0,0,2.737,0,3.727,3.727,0,0,0,1.865-3.228v-3.425Z",
    transform: "translate(13.215 20.774)",
    fill: "#91298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14128",
    "data-name": "Path 14128",
    d: "M33.055,73.741l3.233,1.867-4.1,2.463L28.953,76.2Z",
    transform: "translate(6.17 15.713)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14129",
    "data-name": "Path 14129",
    d: "M23.769,99.349,27,101.214l6.289-23.576-3.232-1.866Z",
    transform: "translate(5.065 16.146)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14130",
    "data-name": "Path 14130",
    d: "M23.769,95.207,27,97.073v3.2a1.375,1.375,0,0,1-2.062,1.19l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(5.065 20.287)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14131",
    "data-name": "Path 14131",
    d: "M40.9,78.357l-3.233,1.936v23.4a1.375,1.375,0,0,0,2.062,1.19l-.4.228a3.132,3.132,0,0,0,1.566-2.714Z",
    transform: "translate(8.026 16.697)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14132",
    "data-name": "Path 14132",
    d: "M30.39,72.2l3.233,1.866-4.1,2.464-3.233-1.866Z",
    transform: "translate(5.602 15.386)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5236",
    "data-name": "Group 5236",
    transform: "translate(25.602 90.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5235",
    "data-name": "Group 5235",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1834",
    "data-name": "Rectangle 1834",
    width: 26.794,
    height: 20.967,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -11.017, 19.082)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5238",
    "data-name": "Group 5238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5237",
    "data-name": "Group 5237",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14134",
    "data-name": "Path 14134",
    d: "M21.105,93.669l3.232,1.867v3.2a1.374,1.374,0,0,1-2.061,1.19l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(4.497 19.96)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14135",
    "data-name": "Path 14135",
    d: "M35.719,75.28l3.233,1.866-4.1,2.464-3.233-1.866Z",
    transform: "translate(6.737 16.041)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5240",
    "data-name": "Group 5240",
    transform: "translate(32.067 93.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5239",
    "data-name": "Group 5239",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1836",
    "data-name": "Rectangle 1836",
    width: 26.794,
    height: 20.967,
    transform: "translate(-11.017 19.082) rotate(-60)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5242",
    "data-name": "Group 5242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5241",
    "data-name": "Group 5241",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14137",
    "data-name": "Path 14137",
    d: "M26.434,96.746l3.233,1.867v3.2A1.375,1.375,0,0,1,27.6,103l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(5.633 20.615)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14138",
    "data-name": "Path 14138",
    d: "M27.725,70.664l3.233,1.867-4.1,2.463-3.233-1.866Z",
    transform: "translate(5.034 15.058)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14139",
    "data-name": "Path 14139",
    d: "M18.44,96.271l3.233,1.866,6.289-23.576L24.729,72.7Z",
    transform: "translate(3.929 15.49)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14140",
    "data-name": "Path 14140",
    d: "M18.44,92.13,21.673,94v3.2a1.375,1.375,0,0,1-2.062,1.19l.4.228A3.132,3.132,0,0,1,18.44,95.9Z",
    transform: "translate(3.929 19.632)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14141",
    "data-name": "Path 14141",
    d: "M22.4,67.587l3.233,1.867-4.1,2.463-3.233-1.866Z",
    transform: "translate(3.898 14.402)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14142",
    "data-name": "Path 14142",
    d: "M13.111,93.194l3.233,1.866,6.289-23.576L19.4,69.618Z",
    transform: "translate(2.794 14.835)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14143",
    "data-name": "Path 14143",
    d: "M13.111,89.053l3.233,1.866v3.2a1.375,1.375,0,0,1-2.062,1.19l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(2.794 18.976)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14144",
    "data-name": "Path 14144",
    d: "M19.732,66.049l3.233,1.866-4.1,2.464L15.63,68.512Z",
    transform: "translate(3.331 14.074)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5244",
    "data-name": "Group 5244",
    transform: "translate(12.672 82.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5243",
    "data-name": "Group 5243",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838",
    "data-name": "Rectangle 1838",
    width: 26.795,
    height: 20.968,
    transform: "translate(-11.017 19.082) rotate(-60)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5246",
    "data-name": "Group 5246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5245",
    "data-name": "Group 5245",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14146",
    "data-name": "Path 14146",
    d: "M10.446,87.515l3.233,1.867v3.2a1.375,1.375,0,0,1-2.062,1.19l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(2.226 18.648)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14147",
    "data-name": "Path 14147",
    d: "M25.061,69.126l3.233,1.866-4.1,2.464-3.233-1.866Z",
    transform: "translate(4.466 14.73)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5248",
    "data-name": "Group 5248",
    transform: "translate(19.136 86.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5247",
    "data-name": "Group 5247",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1840",
    "data-name": "Rectangle 1840",
    width: 26.795,
    height: 20.968,
    transform: "translate(-11.017 19.082) rotate(-60)",
    fill: "#e4eff7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5250",
    "data-name": "Group 5250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5249",
    "data-name": "Group 5249",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14149",
    "data-name": "Path 14149",
    d: "M15.775,90.592l3.233,1.867v3.2a1.375,1.375,0,0,1-2.062,1.19l.4.228a3.132,3.132,0,0,1-1.566-2.712Z",
    transform: "translate(3.361 19.304)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14150",
    "data-name": "Path 14150",
    d: "M17.067,64.51,20.3,66.377,16.2,68.84l-3.233-1.866Z",
    transform: "translate(2.763 13.746)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14151",
    "data-name": "Path 14151",
    d: "M7.782,90.117l3.233,1.866L17.3,68.407,14.07,66.541Z",
    transform: "translate(1.658 14.179)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14152",
    "data-name": "Path 14152",
    d: "M7.781,85.976l3.233,1.866v3.2a1.374,1.374,0,0,1-2.061,1.19l.4.228a3.131,3.131,0,0,1-1.567-2.712Z",
    transform: "translate(1.658 18.32)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14153",
    "data-name": "Path 14153",
    d: "M38.384,76.818l3.233,1.866-4.1,2.464-3.233-1.866Z",
    transform: "translate(7.305 16.369)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14154",
    "data-name": "Path 14154",
    d: "M29.1,102.426l3.233,1.867L38.62,80.715l-3.233-1.866Z",
    transform: "translate(6.201 16.802)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M32.331,104.057,38.62,80.479l.869-.526v23.4a3.726,3.726,0,0,1-1.863,3.228,1.374,1.374,0,0,1-2.061-1.19v.228a3.727,3.727,0,0,1-1.865,3.228,2.737,2.737,0,0,1-2.737,0,3.727,3.727,0,0,1-1.865-3.228V102.19Z",
    transform: "translate(6.2 17.037)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M112.576,52.693l2.55,1.481a2.835,2.835,0,0,0-2.857.28l-2.55-1.481a2.832,2.832,0,0,1,2.857-.28",
    transform: "translate(23.38 11.17)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14157",
    "data-name": "Path 14157",
    d: "M64.8,94.852l-2.55-1.481A2.813,2.813,0,0,1,61.075,90.8l2.55,1.481A2.81,2.81,0,0,0,64.8,94.852",
    transform: "translate(13.014 19.347)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14158",
    "data-name": "Path 14158",
    d: "M63.628,93.559l-2.55-1.481-.021-7.3,2.55,1.482Z",
    transform: "translate(13.011 18.065)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14159",
    "data-name": "Path 14159",
    d: "M66.906,86.128l-2.55-1.481,55.029-31.772,2.55,1.482Z",
    transform: "translate(13.714 11.267)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14160",
    "data-name": "Path 14160",
    d: "M63.608,87.478,61.058,86a8.82,8.82,0,0,1,4-6.932l2.549,1.482a8.819,8.819,0,0,0-4,6.93",
    transform: "translate(13.011 16.848)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14161",
    "data-name": "Path 14161",
    d: "M122.19,54.194c2.218-1.28,4.02-.252,4.027,2.3l.021,7.3a8.819,8.819,0,0,1-4,6.93L67.208,102.489c-2.218,1.28-4.02.252-4.027-2.3l-.021-7.3a8.817,8.817,0,0,1,4-6.932Z",
    transform: "translate(13.459 11.431)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14170",
    "data-name": "Path 14170",
    d: "M103.7,63.974l1.275.741.033.021-1.274-.741-.034-.021",
    transform: "translate(22.097 13.632)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14221",
    "data-name": "Path 14221",
    d: "M139.258,44.19,53.978,93.426V80.4l85.28-49.234Z",
    transform: "translate(11.502 6.641)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14222",
    "data-name": "Path 14222",
    d: "M0,49.236,85.279,0,150.76,37.806,65.48,87.04Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14223",
    "data-name": "Path 14223",
    d: "M82.294,5.594l54.647,31.551-72.6,41.917L9.689,47.511Z",
    transform: "translate(2.065 1.192)",
    fill: "#d6edfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14224",
    "data-name": "Path 14224",
    d: "M82.294,5.594,9.689,47.511l3.4,1.962L75.642,13.357l49.29,28.457L62.376,77.93l1.962,1.133,72.6-41.917Z",
    transform: "translate(2.065 1.192)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14225",
    "data-name": "Path 14225",
    d: "M0,53.612l65.48,37.8V78.392L0,40.587Z",
    transform: "translate(0 8.649)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14226",
    "data-name": "Path 14226",
    d: "M82.294,13.357,130.22,41.026l6.722-3.881L82.294,5.594,9.689,47.512l6.723,3.881Z",
    transform: "translate(2.065 1.192)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14227",
    "data-name": "Path 14227",
    d: "M82.294,13.357,16.412,51.393,9.689,47.512,82.294,5.594Z",
    transform: "translate(2.065 1.192)",
    fill: "url(#linear-gradient-13)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5252",
    "data-name": "Group 5252",
    transform: "translate(53 129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5096",
    "data-name": "Group 5096",
    transform: "translate(354.848 51.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5095",
    "data-name": "Group 5095",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    width: 32.037,
    height: 39.034,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5098",
    "data-name": "Group 5098",
    transform: "translate(339.273 35.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5097",
    "data-name": "Group 5097",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1770",
    "data-name": "Rectangle 1770",
    width: 51.854,
    height: 86.761,
    transform: "translate(-0.001 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5100",
    "data-name": "Group 5100",
    transform: "translate(348.16 40.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5099",
    "data-name": "Group 5099",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 50.404,
    height: 81.813,
    transform: "translate(-0.046 0)",
    fill: "url(#linear-gradient)"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1804",
    "data-name": "Rectangle 1804",
    width: 911,
    height: 694.651,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllLocater);
export default __webpack_public_path__ + "static/media/ill-locater.5fc3bd8fdb2e2444fa27fdbf4031dc07.svg";
export { ForwardRef as ReactComponent };